// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"84654371","415":"66eafed1","513":"18e4df12","787":"f015732e"}[chunkId] + ".chunk.js";
};